import createReducer from 'redux/lib/reducerConfig';

export const ActionTypes = {
  SET_DATA: 'MARKET_PRICE/COMPOSITES/SET_DATA',
  UPDATE_DATA: 'MARKET_PRICE/COMPOSITES/UPDATE_DATA',
  SET_PAGE: 'MARKET_PRICE/COMPOSITES/SET_PAGE',
};

export const setCompositesData = (data) => ({ type: ActionTypes.SET_DATA, payload: { data } });
export const updateCompositeData = (newData) => ({ type: ActionTypes.UPDATE_DATA, payload: { data: newData } });

const compositesInitialState = {
  data: [],
};

export const compositesReducer = createReducer(
  compositesInitialState,
  {
    [ActionTypes.SET_DATA]: (state, { payload: { data } }) => {
      return {
        ...state,
        data,
      };
    },
    [ActionTypes.UPDATE_DATA]: (state, { payload: { data }}) => {
      return {
        ...state,
        data: state.data.map((composite) => {
          const newComposite = data.find(({ id }) => id === composite.id);
          return newComposite || composite;
        })
      }
    }
  }
);
